export default {
    emptyTitle: {
        fontSize: '1rem',
    },
};
